import Image from "next/image";

/** Keep the wordmark as live text so it stays crisp at every screen size. */
export function Brand() {
  return <>
    <Image src="/images/brand/ponderchess-knight.webp" alt="" width={44} height={44} className="brand-mark" unoptimized />
    <span className="brand-wordmark">Ponder<span>chess</span></span>
  </>;
}
